import React from "react";
import image1 from "../logos/elhidevices1.png";
import image2 from "../logos/elhidevices2.png";
import "./CommonDashboard.css";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";
import { setEmms } from "../redux/slices/emmsSlice";
import { setCurrentEmms } from "../redux/slices/currentEmmsSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

const ElhiDeviceLandingDashboard = () => {
 
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  
 
  


  function fetchData() {
    const api = localStorage.getItem("api");
    axios
      .get(api + `/list/emms`, headers)
      .then((response) => {
        dispatch(setEmms(response.data));
        dispatch(setCurrentEmms(response.data[0]));
        const emmsheaders = {
          headers: {
            "Content-Type": "application/json",
            "x-api-id": response.data[0]?.apiId,
            "x-api-key": response.data[0]?.apiKey,
          },
        };
        dispatch(setEmmsHeaders(emmsheaders));
      })
      .catch((error) => {
        console.error(error);
      });
  }
  React.useEffect(() => {
    fetchData();
  }, []);

  
  return (
    <div>
      <div className="mainContainer emms-main-container">
        <header>
          <figure>
            <img className="img" src={image1} alt="Logo" />
          </figure>
          <figure>
            <img className="img" src={image2} alt="Logo" />
          </figure>
        </header>
      </div>
    </div>
  );
};

export default ElhiDeviceLandingDashboard;
